import { render, staticRenderFns } from "./BankAccountIndex.vue?vue&type=template&id=3f019f5f&scoped=true&"
import script from "./BankAccountIndex.vue?vue&type=script&lang=js&"
export * from "./BankAccountIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f019f5f",
  null
  
)

export default component.exports